<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="{{ modalId }}">Add Race</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <div class="input-group mb-3">
                <input [(ngModel)]="race.name" type="text" class="form-control" placeholder="Race Name" aria-label="Race name">
            </div>
            <div ngbAccordion #acc="ngbAccordion" [closeOthers]="true" activeIds="ngb-panel-0">
                <div ngbAccordionItem>
                    <div ngbAccordionHeader class="d-flex align-items-center justify-content-between">
                        <button ngbAccordionButton class="btn btn-link container-fluid text-left pl-0 m-0 h5">
                            Begin Date - <span *ngIf="!race.begin"><em>not set</em></span>{{ race.begin?.toDate() | date:'yyyy/MM/dd h:mm:ss a' }}
                        </button>
                    </div>
                    <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                            <ng-template>
                                <app-date-time-picker [(timestamp)]="race.begin"></app-date-time-picker>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div ngbAccordionItem>
                    <div ngbAccordionHeader class="d-flex align-items-center justify-content-between">
                        <button ngbAccordionButton class="btn btn-link container-fluid text-left pl-0 m-0 h5">
                            End Date - <span *ngIf="!race.end"><em>not set (optional)</em></span>{{ race.end?.toDate() | date:'yyyy/MM/dd h:mm:ss a' }}
                        </button>
                    </div>
                    <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                            <ng-template>
                                <app-date-time-picker [(timestamp)]="race.end"></app-date-time-picker>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" [disabled]="race.name?.trim() =='' || !race.name || !race.begin" (click)="add()">Save</button>
    </div>
</ng-template>

<button *ngIf="auth.currentUser" class="btn btn-outline-primary" (click)="open(content)">Create New Race</button>